import graphqlClient from '@/graphql/graphql-client';
import { useMutation } from '@tanstack/react-query';
import {
  UpdateTaskCommentDocument,
  type UpdateTaskCommentMutationVariables,
} from '@/graphql/generated/graphql';

export type UpdateTaskCommentVariables = UpdateTaskCommentMutationVariables;

export const useUpdateTaskComment = () => {
  const mutation = useMutation({
    mutationKey: ['update-task-comment'],
    mutationFn: (variables: UpdateTaskCommentMutationVariables) =>
      graphqlClient.request(UpdateTaskCommentDocument, variables),
  });

  return {
    ...mutation,
    updateTaskComment: mutation.mutate,
    updateTaskCommentAsync: mutation.mutateAsync,
  };
};

export const UPDATE_TASK_COMMENTS_MUTATION = UpdateTaskCommentDocument;
